import React from "react";
import "./ContactHeroSection.css";
import { FaComments, FaPhoneAlt, FaEnvelopeOpenText } from "react-icons/fa";

const ContactHeroSection = () => {
  return (
    <section className="contact-hero">
      {/* Floating icons */}
      <div className="floating-icons">
        <FaComments className="icon chat" />
        <FaPhoneAlt className="icon phone" />
        <FaEnvelopeOpenText className="icon mail" />
      </div>

      {/* Main content */}
      <div className="contact-hero-content">
        <h1>
          Get in Touch with <span>MBR Network’s</span>
        </h1>
        <p>
          Whether you’re a student, business owner, or creator — we’d love to
          connect with you. Let’s build something impactful together!
        </p>

        <div className="contact-buttons">
          <button className="btn-primary">Contact Us</button>
          <button className="btn-secondary">Join Our Network</button>
        </div>
      </div>
    </section>
  );
};

export default ContactHeroSection;
